/** The pure rules of the home pill (1.J deliverable 19). */
import type { LinkCreateV1, LinkUpdateV1, LinkV1 } from '@codex/contracts';

export type HomeWrite =
  | {
      readonly kind: 'update';
      /** The document that owns the link: the new home. */
      readonly ownerId: string;
      readonly linkId: string;
      readonly body: LinkUpdateV1;
    }
  | { readonly kind: 'create'; readonly ownerId: string; readonly body: LinkCreateV1 };

/**
 * Makes `parentId` this page's home: when a live `contains` link from that parent to the page
 * exists (`incoming`, the page's incoming `contains` links), it is made primary; otherwise one is
 * created on the parent.
 */
export function homeWrite(
  incoming: readonly Pick<LinkV1, 'id' | 'rv' | 'sourceId'>[],
  parentId: string,
  docId: string,
): HomeWrite {
  const existing = incoming.find((link) => link.sourceId === parentId);
  if (existing) {
    return {
      kind: 'update',
      ownerId: parentId,
      linkId: existing.id,
      body: { baseRv: existing.rv, isPrimary: true },
    };
  }
  return {
    kind: 'create',
    ownerId: parentId,
    body: { linkTypeKey: 'contains', targetId: docId, isPrimary: true },
  };
}

/** "Remove home": the primary link stays and is only made non-primary. Null without a home. */
export function removeHomeWrite(
  incoming: readonly Pick<LinkV1, 'id' | 'rv' | 'sourceId' | 'isPrimary'>[],
): Extract<HomeWrite, { kind: 'update' }> | null {
  const primary = incoming.find((link) => link.isPrimary);
  if (!primary) return null;
  return {
    kind: 'update',
    ownerId: primary.sourceId,
    linkId: primary.id,
    body: { baseRv: primary.rv, isPrimary: false },
  };
}

/** The pill's text. */
export function pillText(homeTitle: string | null): string {
  return homeTitle === null ? 'No home' : `Home: ${homeTitle}`;
}
